import {
  ttt,
  createTrackingHoc,
  matchEnvByHost,
  // @ts-expect-error TS(7016) FIXME: Could not find a declaration file for module '@xin... Remove this comment to see the full error message
} from '@xingternal/malt-tracking';

const env = matchEnvByHost({
  localhost: 'development',
  'www.xing.com': 'production',
  default: 'preview',
});

const CHANNEL = 'wbm/Companies';

ttt.init(env, { PropChannel: CHANNEL, fetchTrackingData: true });

// Expose ttt to be reachable from iframe
if (typeof window !== 'undefined') {
  // @ts-expect-error TS(2339) FIXME: Property 'ttt' does not exist on type 'Window & ty... Remove this comment to see the full error message
  window.ttt = ttt;
}

export const trackPage = (pageName: $TSFixMe, extraProps = {}) => {
  ttt.pageview(
    CHANNEL,
    `${CHANNEL}/${pageName}`,
    ttt.assign({}, ttt.baseData, extraProps),
  );
};

export const trackEvent = (
  eventName: $TSFixMe,
  interactionType: $TSFixMe,
  extraProps = {},
) => {
  ttt.event(eventName, {
    [eventName]: 1,
    PropInteractionType: interactionType,
    ...extraProps,
  });
};

export const trackAction = (actionName: $TSFixMe, contextData: $TSFixMe) => {
  ttt.event('PropTrackAction', { PropTrackAction: actionName, ...contextData });
};

export const withPageTracking = createTrackingHoc('pageview');

const addParamToUrl = (url: $TSFixMe, key: $TSFixMe, value: $TSFixMe) => {
  return `${url}${url.split('?')[1] ? '&' : '?'}${key}=${value}`;
};

export const addTrackingParamsToURL = ({ url, params = {} }: $TSFixMe) => {
  let urlWithTracking = url;

  Object.entries(params).forEach(([paramKey, paramValue]) => {
    urlWithTracking = addParamToUrl(url, paramKey, paramValue);
  });

  return urlWithTracking;
};
